(function () {
  if (window.__aeriwearAtelierHomeLoaded) return;
  window.__aeriwearAtelierHomeLoaded = true;

  var reduceMotion = window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function prepareStaggers(root) {
    var groups = (root || document).querySelectorAll("[data-aeh-stagger]");
    groups.forEach(function (group) {
      Array.prototype.forEach.call(group.children, function (child, index) {
        child.classList.add("aeh-reveal");
        child.style.setProperty("--aeh-delay", Math.min(index * 70, 280) + "ms");
      });
    });
  }

  function reveal(root) {
    document.documentElement.classList.add("aeh-page");
    document.documentElement.classList.remove("aeh-can-animate");
    if (document.body) {
      document.body.classList.add("aeh-page");
    }
    prepareStaggers(root);
    var nodes = (root || document).querySelectorAll(".aeh-reveal");
    nodes.forEach(function (node) {
      node.classList.add("is-visible");
    });
  }

  function enhancePointer(root) {
    if (reduceMotion || !window.matchMedia) return;
    if (!window.matchMedia("(pointer: fine)").matches) return;

    var scope = root || document;
    var nodes = scope.querySelectorAll(
      [
        ".aeh-kinetic",
        ".aeh-category",
        ".aeh-custom-item",
        ".aeh-fabric-card",
        ".aeh-factory__main",
        ".aeh-factory__dossier",
        ".aeh-factory__proofs > div",
        ".aeh-faq__list details",
        ".aeh-btn",
      ].join(","),
    );

    if (!nodes.length) return;
    document.documentElement.classList.add("aeh-has-pointer");

    nodes.forEach(function (node) {
      if (node.dataset.aehInteractiveReady === "true") return;
      node.dataset.aehInteractiveReady = "true";
      node.classList.add("aeh-interactive");
      if (!node.matches(".aeh-faq__list details")) {
        node.classList.add("aeh-depth");
      }

      node.addEventListener("pointerenter", function () {
        node.classList.add("is-aeh-hot");
      });

      node.addEventListener("pointermove", function (event) {
        var rect = node.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        var x = (event.clientX - rect.left) / rect.width;
        var y = (event.clientY - rect.top) / rect.height;
        var moveX = (x - 0.5) * 8;
        var moveY = (y - 0.5) * 8;

        node.style.setProperty("--aeh-move-x", moveX.toFixed(2) + "px");
        node.style.setProperty("--aeh-move-y", moveY.toFixed(2) + "px");
      });

      node.addEventListener("pointerleave", function () {
        node.classList.remove("is-aeh-hot");
        node.style.removeProperty("--aeh-move-x");
        node.style.removeProperty("--aeh-move-y");
      });
    });
  }

  function enhanceFaq(root) {
    var scope = root || document;
    var groups = scope.querySelectorAll(".aeh-faq__list");
    groups.forEach(function (group) {
      if (group.dataset.aehFaqReady === "true") return;
      group.dataset.aehFaqReady = "true";
      group.addEventListener("toggle", function (event) {
        var active = event.target;
        if (!active.matches("details") || !active.open) return;
        group.querySelectorAll("details[open]").forEach(function (details) {
          if (details !== active) {
            details.open = false;
          }
        });
      }, true);
    });
  }

  function parseCounterLabel(label) {
    var match = label.trim().match(/^([^0-9]*)([0-9][0-9,]*(?:\.[0-9]+)?)(.*)$/);
    if (!match) return null;
    var rawNumber = match[2];
    var target = Number(rawNumber.replace(/,/g, ""));
    if (!Number.isFinite(target)) return null;
    var decimals = rawNumber.indexOf(".") > -1 ? rawNumber.split(".")[1].length : 0;
    return {
      prefix: match[1],
      suffix: match[3],
      target: target,
      decimals: decimals,
    };
  }

  function formatCounter(value, decimals) {
    if (decimals > 0) {
      return value.toFixed(decimals);
    }
    return Math.round(value).toLocaleString("en-US");
  }

  function animateCounter(node, index) {
    if (node.dataset.aehCounterDone === "true") return;
    var original = node.dataset.aehCounterOriginal || node.textContent.trim();
    var parsed = parseCounterLabel(original);
    if (!parsed) return;

    node.dataset.aehCounterOriginal = original;
    node.dataset.aehCounterDone = "true";

    var delay = Math.min(index * 55, 130);
    var duration = 620;

    window.setTimeout(function () {
      var start = null;

      function tick(timestamp) {
        if (start === null) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 4);
        var current = parsed.target * eased;

        node.textContent = parsed.prefix + formatCounter(current, parsed.decimals) + parsed.suffix;

        if (progress < 1) {
          window.requestAnimationFrame(tick);
          return;
        }

        node.textContent = original;
      }

      window.requestAnimationFrame(tick);
    }, delay);
  }

  function enhanceProofCounters(root) {
    if (reduceMotion || !window.requestAnimationFrame) return;
    var scope = root || document;
    var groups = scope.querySelectorAll(".aeh-proof-metrics");
    groups.forEach(function (group) {
      if (group.dataset.aehCounterReady === "true") return;
      group.dataset.aehCounterReady = "true";
      var counters = Array.prototype.slice.call(group.querySelectorAll(".aeh-proof-metric strong"));
      if (!counters.length) return;

      var startCounters = function () {
        counters.forEach(function (counter, index) {
          animateCounter(counter, index);
        });
      };

      if (!("IntersectionObserver" in window)) {
        startCounters();
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            startCounters();
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.35, rootMargin: "0px 0px -10% 0px" },
      );

      observer.observe(group);
    });
  }

  var editorialMotionBooted = false;
  var editorialMotionLoading = null;
  var animatedSections = new WeakSet();
  var parallaxImages = new WeakSet();
  var motionScriptIds = {
    gsap: "aeh-gsap-core",
    scrollTrigger: "aeh-gsap-scrolltrigger",
  };

  function loadScriptOnce(src, id) {
    return new Promise(function (resolve, reject) {
      var existing = document.getElementById(id);
      if (existing) {
        if (existing.dataset.aehLoaded === "true") {
          resolve();
          return;
        }
        existing.addEventListener("load", function () {
          resolve();
        }, { once: true });
        existing.addEventListener("error", reject, { once: true });
        return;
      }

      var script = document.createElement("script");
      script.id = id;
      script.src = src;
      script.async = true;
      script.onload = function () {
        script.dataset.aehLoaded = "true";
        resolve();
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  function loadGsap() {
    if (reduceMotion) return Promise.resolve(null);
    if (window.gsap && window.ScrollTrigger) {
      return Promise.resolve({
        gsap: window.gsap,
        ScrollTrigger: window.ScrollTrigger,
      });
    }
    if (editorialMotionLoading) return editorialMotionLoading;

    editorialMotionLoading = loadScriptOnce(
      "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js",
      motionScriptIds.gsap,
    )
      .then(function () {
        if (window.ScrollTrigger) return;
        return loadScriptOnce(
          "https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js",
          motionScriptIds.scrollTrigger,
        );
      })
      .then(function () {
        if (!window.gsap || !window.ScrollTrigger) return null;
        window.gsap.registerPlugin(window.ScrollTrigger);
        return {
          gsap: window.gsap,
          ScrollTrigger: window.ScrollTrigger,
        };
      })
      .catch(function () {
        return null;
      });

    return editorialMotionLoading;
  }

  function uniqueNodes(nodes) {
    var seen = [];
    Array.prototype.forEach.call(nodes || [], function (node) {
      if (!node || seen.indexOf(node) > -1) return;
      seen.push(node);
    });
    return seen;
  }

  function splitWords(element) {
    if (!element || element.dataset.aehSplit === "true") {
      return Array.prototype.slice.call(element ? element.querySelectorAll(".aeh-word-inner") : []);
    }

    var text = element.textContent.replace(/\s+/g, " ").trim();
    if (!text) return [];

    element.dataset.aehSplit = "true";
    element.setAttribute("aria-label", text);
    element.textContent = "";

    text.split(" ").forEach(function (word, index, words) {
      var mask = document.createElement("span");
      var inner = document.createElement("span");
      mask.className = "aeh-word-mask";
      inner.className = "aeh-word-inner";
      inner.textContent = word;
      mask.appendChild(inner);
      element.appendChild(mask);
      if (index < words.length - 1) {
        element.appendChild(document.createTextNode(" "));
      }
    });

    return Array.prototype.slice.call(element.querySelectorAll(".aeh-word-inner"));
  }

  function clearMotionProps(node) {
    if (!node) return;
    node.style.removeProperty("will-change");
    node.style.removeProperty("transform");
    node.style.removeProperty("opacity");
    node.style.removeProperty("filter");
    node.style.removeProperty("visibility");
  }

  function runOpeningAnimation() {
    if (reduceMotion || !("animate" in Element.prototype)) return;
    var heroSection = document.querySelector(".aeriwear-balanced-banner");
    if (!heroSection || heroSection.dataset.aehOpeningDone === "true") return;

    var title = heroSection.querySelector(".m-hero__title");
    if (!title) return;

    heroSection.dataset.aehOpeningDone = "true";
    heroSection.classList.add("aeh-opening-section");

    var subtitle = heroSection.querySelector(".m-hero__subtitle");
    var text = heroSection.querySelector(".m-hero__text");
    var button = heroSection.querySelector(".m-hero__btn, .m-button");
    var words = splitWords(title);

    var introNodes = uniqueNodes([subtitle, text, button]);
    var easing = "cubic-bezier(0.16, 1, 0.3, 1)";

    if (words.length) {
      words.forEach(function (word, index) {
        word.style.transform = "translateY(118%) scaleY(0.68) rotateX(-18deg)";
        word.style.transformOrigin = "50% 100%";
        word.style.willChange = "transform";
        var animation = word.animate([
          { transform: "translateY(118%) scaleY(0.68) rotateX(-18deg)" },
          { transform: "translateY(0%) scaleY(1) rotateX(0deg)" },
        ], {
          duration: 1180,
          delay: 120 + index * 55,
          easing: easing,
          fill: "both",
        });
        animation.addEventListener("finish", function () {
          clearMotionProps(word);
        }, { once: true });
      });
    } else {
      title.style.opacity = "0";
      title.style.transform = "translateY(82px) scaleY(0.78)";
      title.style.filter = "blur(10px)";
      title.style.willChange = "transform, opacity, filter";
      var titleAnimation = title.animate([
        { opacity: 0, transform: "translateY(82px) scaleY(0.78)", filter: "blur(10px)" },
        { opacity: 1, transform: "translateY(0) scaleY(1)", filter: "blur(0px)" },
      ], {
        duration: 1120,
        delay: 120,
        easing: easing,
        fill: "both",
      });
      titleAnimation.addEventListener("finish", function () {
        clearMotionProps(title);
      }, { once: true });
    }

    if (introNodes.length) {
      introNodes.forEach(function (node, index) {
        node.style.opacity = "0";
        node.style.transform = "translateY(34px)";
        node.style.filter = "blur(8px)";
        node.style.willChange = "transform, opacity, filter";
        var animation = node.animate([
          { opacity: 0, transform: "translateY(34px)", filter: "blur(8px)" },
          { opacity: 1, transform: "translateY(0)", filter: "blur(0px)" },
        ], {
          duration: 1050,
          delay: 480 + index * 110,
          easing: "cubic-bezier(0.25, 1, 0.5, 1)",
          fill: "both",
        });
        animation.addEventListener("finish", function () {
          clearMotionProps(node);
        }, { once: true });
      });
    }
  }

  function getSectionHeading(section) {
    var selectors = [
      ".aeh-proof-heading",
      ".aeh-h1",
      ".aeh-h2",
      ".aw-h1",
      ".aw-h2",
      ".m-section__heading",
      ".m-richtext__title",
      ".m-testimonials__heading",
      ".m-testimonials__header h2",
      ".m-testimonials__header h3",
      ".m-custom-content__block h2",
      ".m-custom-content__block h3",
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var found = section.querySelector(selectors[i]);
      if (found) return found;
    }

    return section.querySelector("h1, h2");
  }

  function getSectionCards(section) {
    var cardSelector = [
      ".aeh-path-row",
      ".aeh-process-track article",
      ".aeh-custom-item",
      ".aeh-fabric-card",
      ".aeh-factory__proofs > div",
      ".aeh-quote-prep__row",
      ".aeh-proof-metric",
      ".aw-category",
      ".aw-capability",
      ".aw-mini-path",
      ".aw-custom-item",
      ".aw-fabric-card",
      ".aw-quote",
      ".m-custom-content__block",
      ".m-testimonials .swiper-slide",
      ".m-testimonials__item",
      ".m-testimonial",
    ].join(",");

    return uniqueNodes(section.querySelectorAll(cardSelector)).filter(function (node) {
      return !node.closest(".aeriwear-balanced-banner");
    }).slice(0, 12);
  }

  function getSectionImages(section) {
    var imageSelector = [
      ".aeh-frame",
      ".aeh-proof-media",
      ".aw-category",
      ".aw-look",
      ".aw-fabric-media",
      ".aw-custom-gallery .photo",
      ".m-image-comparison",
      ".m-custom-content__block",
    ].join(",");

    return uniqueNodes(section.querySelectorAll(imageSelector)).filter(function (node) {
      return !node.closest(".aeriwear-balanced-banner") &&
        !node.closest(".aeh-factory__dossier");
    }).slice(0, 8);
  }

  function isTestimonialsSection(section) {
    return !!(
      section &&
      (
        section.matches("section[data-section-type='testimonials'], .m-testimonials") ||
        section.querySelector("m-testimonials, .m-testimonials-el")
      )
    );
  }

  function animateSectionOnScroll(section, gsap, ScrollTrigger) {
    if (!section || animatedSections.has(section)) return;
    if (section.closest(".aeriwear-balanced-banner")) return;
    if (section.id && section.id.indexOf("1774313208eaec305a") > -1) return;

    var heading = getSectionHeading(section);
    var cards = getSectionCards(section);
    var isTestimonials = isTestimonialsSection(section);
    var allImageFrames = getSectionImages(section);
    var imageFrames = allImageFrames.filter(function (node) {
      return cards.indexOf(node) === -1;
    });
    var imageTargets = uniqueNodes(allImageFrames.map(function (frame) {
      return frame.matches("img") ? frame : frame.querySelector("img");
    }));
    if (!heading && !cards.length && !allImageFrames.length) return;

    animatedSections.add(section);

    ScrollTrigger.create({
      trigger: section,
      start: isTestimonials ? "top 92%" : "top 78%",
      once: true,
      onEnter: function () {
        var supportClip = window.CSS && window.CSS.supports && window.CSS.supports("clip-path", "inset(0% 0% 0% 0%)");
        var tl = gsap.timeline({
          defaults: { ease: "expo.out" },
          onComplete: function () {
            gsap.set(uniqueNodes([heading].concat(cards).concat(imageFrames).concat(imageTargets)), {
              clearProps: "willChange,transform,opacity,filter,clipPath,visibility",
            });
          },
        });

        if (heading) {
          gsap.set(heading, {
            transformOrigin: "0% 100%",
            willChange: "transform, filter",
          });
          tl.fromTo(heading, {
            y: 88,
            scaleY: 0.82,
            filter: "blur(10px)",
          }, {
            y: 0,
            scaleY: 1,
            filter: "blur(0px)",
            duration: isTestimonials ? 0.92 : 1.34,
            ease: "expo.out",
          }, 0);
        }

        if (imageFrames.length) {
          gsap.set(imageFrames, {
            overflow: "hidden",
            willChange: "clip-path",
          });
          tl.fromTo(imageFrames, {
            clipPath: supportClip ? "inset(16% 0% 18% 0%)" : undefined,
          }, {
            clipPath: supportClip ? "inset(0% 0% 0% 0%)" : undefined,
            duration: 1.35,
            stagger: 0.07,
            ease: "power4.out",
          }, heading ? 0.22 : 0);
        }

        if (cards.length) {
          gsap.set(cards, {
            willChange: "opacity, clip-path, filter",
          });
          tl.fromTo(cards, {
            autoAlpha: 0,
            filter: "blur(8px)",
            clipPath: supportClip ? "inset(14% 0% 0% 0%)" : undefined,
          }, {
            autoAlpha: 1,
            filter: "blur(0px)",
            clipPath: supportClip ? "inset(0% 0% 0% 0%)" : undefined,
            duration: isTestimonials ? 0.72 : 1.08,
            stagger: isTestimonials ? 0.055 : 0.115,
            ease: "power4.out",
          }, heading ? (isTestimonials ? 0.2 : 0.44) : 0.1);
        }
      },
    });
  }

  function collectMotionSections(scope) {
    var root = scope || document;
    var selectors = [
      ".aeh[data-aeh]",
      ".aw-home",
      "section[data-section-type='custom-content']",
      "section[data-section-type='testimonials']",
      ".m-custom-content",
      ".m-testimonials",
    ].join(",");

    return uniqueNodes(root.querySelectorAll(selectors)).filter(function (section) {
      return !section.closest("header") &&
        !section.closest("footer") &&
        !section.closest(".aeriwear-balanced-banner") &&
        !(section.id && section.id.indexOf("1774313208eaec305a") > -1);
    });
  }

  function enhanceParallaxImages(scope, gsap, ScrollTrigger) {
    return;
  }

  function enhanceEditorialMotion(root) {
    if (reduceMotion || !document.body) return;

    if (!editorialMotionBooted) {
      editorialMotionBooted = true;
      runOpeningAnimation();
    }

    var startScrollMotion = function () {
      loadGsap().then(function (bundle) {
        if (!bundle) return;
        var gsap = bundle.gsap;
        var ScrollTrigger = bundle.ScrollTrigger;
        document.documentElement.classList.add("aeh-motion-enhanced");

        collectMotionSections(root || document).forEach(function (section) {
          animateSectionOnScroll(section, gsap, ScrollTrigger);
        });
        enhanceParallaxImages(root || document, gsap, ScrollTrigger);
        ScrollTrigger.refresh();
      });
    };

    var schedule = function () {
      if ("requestIdleCallback" in window) {
        window.requestIdleCallback(startScrollMotion, { timeout: 1400 });
        return;
      }
      window.setTimeout(startScrollMotion, 650);
    };

    if (document.readyState === "complete") {
      schedule();
    } else {
      window.addEventListener("load", schedule, { once: true });
    }
  }

  function boot(root) {
    reveal(root);
    enhancePointer(root);
    enhanceFaq(root);
    enhanceProofCounters(root);
    enhanceEditorialMotion(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
